module.exports = __webpack_public_path__ + "media/images/gallery/constellations/libra/lib_gc-72fa9fc829c714665876f0c0e71bda09.gif";